import * as React from 'react';
import { MultipleAnswers } from './MultipleAnswers';
import { MultipleChoice } from './MultipleChoice';
import { jsx as ___EmotionJSX } from "@emotion/react";
export const AnswerPanel = _ref => {
  let {
    checkExercise,
    exercise,
    exerciseId
  } = _ref;
  switch (exercise.question.flavor) {
    case 'PureMultipleChoice':
      return ___EmotionJSX(MultipleChoice, {
        checkExercise: checkExercise,
        exerciseId: exerciseId,
        solutionItems: exercise.question.solutionItems
      });
    case 'PureMultipleAnswers':
      return ___EmotionJSX(MultipleAnswers, {
        checkExercise: checkExercise,
        exerciseId: exerciseId,
        solutionItems: exercise.question.solutionItems,
        successMessage: exercise.question.successMessage
      });
    default:
      throw new Error('Flavor not found');
  }
};